<!--
 * @FileDescription: 布局组件
 * @Author: 苏子龙
 * @Date: 未知
 * @LastEditors: 陈文景
 * @LastEditTime: 2022-09-22 14:29:35
-->
<template>
  <div :class="['layout', { hideSidebar: isCollapse }]" :style="{ paddingLeft: isCollapse ? '64px' : '208px' }">
    <!-- 左侧菜单 -->
    <div class="menu bg-white hidden-scroll-bar">
      <!-- logo -->
      <div class="logo f-c-c">
        <img v-show="!isCollapse" src="~@/assets/img/logo.png" style="width: 162px; height: 39px;" />
        <img v-show="isCollapse" src="~@/assets/img/small_logo.png" style="width: 34px; height: 34px;" />
      </div>

      <!-- 菜单 -->
      <el-scrollbar wrap-class="scrollbar-wrapper">
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo" unique-opened @open="handleOpen" @close="handleClose" @select="handleSelect" :collapse="isCollapse" mode="vertical" active-text-color="#bbd867" style="border: none" :collapse-transition="false">
          <!-- <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-s-custom" />
              <span slot="title">用户</span>
            </template>
            <el-menu-item index="/user/chat">会话</el-menu-item>
            <el-menu-item index="/user/user">用户管理</el-menu-item>
            <el-menu-item index="/user/roles">角色管理</el-menu-item>
            <el-menu-item index="/user/permission">权限管理</el-menu-item>
          </el-submenu> -->
          <sidebar-item v-for="menu in menus" :key="menu.id" :item="menu" />
        </el-menu>
      </el-scrollbar>
    </div>

    <!-- 菜单收起/展开按钮 -->
    <div class="menu-close-but pointer f-c-c" @click="$store.dispatch('setIsCollapse', !isCollapse)" :style="{ left: isCollapse ? '46px' : '190px' }">
      <i :class="['iconfont', isCollapse ? 'icon-a-arrow-right-s-line1' : 'icon-a-arrow-left-s-line2']" style="font-size: 24px;" />
    </div>

    <!-- header -->
    <div class="header f-b-c" :style="{ width: `calc(100vw - ${isCollapse ? '64px' : '208px'})`, left: `${isCollapse ? '64px' : '208px'}` }">
      <div class="f f--c" style="margin-left:14px;flex:1">
        <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{ breadcrumbFirst }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="$route.meta.father.path" v-if="$route.meta.father">{{ $route.meta.father.name }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ nowPathName }}</el-breadcrumb-item>
        </el-breadcrumb> -->
        <el-tabs v-model="activeKey" type="card" closable class="nav-tab" @tab-remove="removeTab" @tab-click="clickTab" :style="{width: `calc(100vw - ${isCollapse ? '264px' : '408px'})`}">
          <el-tab-pane
            v-for="item in $store.getters.tabs"
            :key="item.key"
            :label="item.name"
            :name="item.key"
          >
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="user pointer">
        <el-dropdown @command="(fun) => this[fun]()">
          <span>
            <span>{{ fullName }}</span>
            <i class="el-icon-arrow-down el-icon--right" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logOut">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="layout-main">
      <!-- TODO 此处组件缓存待完善 -->
      <keep-alive :include="catchPagesString">
        <router-view />
      </keep-alive>
      <!-- <router-view v-if="!$route.meta.keepAlive" /> -->

      <!-- <keep-alive :max="10" :exclude="not_keepAlive">
        <router-view />
      </keep-alive> -->
    </div>
  </div>
</template>

<script>
import API from '@/api'
import SidebarItem from './SidebarItem.vue'

// 不缓存的组件
const NOT_KEEPALIVE = [
  'orders_all-orders',
  'report_userStatistics',
  'report_userStatistcBy',
  'report_pageStatistics',
  'statistics_product-statistics'
]

export default {
  components: {
    'sidebar-item': SidebarItem
  },
  data() {
    return {
      menus: this.$store.getters.menus,
      fullName: this.$store.getters.userName,
      tabs: [],
      activeKey: '/dashboard',
      catchPagesString: [],
      not_keepAlive: NOT_KEEPALIVE
    }
  },
  computed: {
    isCollapse() {
      return this.$store.getters.isCollapse
    },
    breadcrumbFirst() {
      let firstName = ''
      this.$router.options.routes.forEach((e) => {
        if (e.children && e.children.find((e) => e.name === this.$route.name)) firstName = e.name
      })
      return firstName
    },
    nowPathName() {
      return this.$route.name
    },
    catchPages: function() {
      return this.$store.state.user.tabs
    }
  },
  watch: {
    '$store.state.user.activeTab': function(v) {
      this.activeKey = v.key
    },
    catchPages: function(catchPages) {
      this.catchPagesString = catchPages.map(item => item.pageName)
    }
  },
  mounted() {
    this.activeKey = this.$store.state.user.activeTab.key
    this.catchPagesString = this.catchPages.map(item => item.pageName)
  },
  methods: {
    handleOpen() {},

    handleClose() {},

    handleSelect(path) {
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    },

    logOut() {
      API.logout().then(() => {
        this.$store.dispatch('user/logout')
        this.$router.replace('/login')
      })
    },

    removeTab(key) {
      this.$store.commit('user/deleteTab', {
        key,
        isJump: true
      })
    },
    clickTab(tab, event) {
      this.$store.commit('user/setActiveTab', tab.name)
    },
  }
}
</script>

<style lang="scss" scoped>
.layout {
  padding: 40px 0 0 208px;
}

.layout-main {
  height: calc(100vh - 40px);
  padding: 12px;
}

.menu-close-but {
  border-radius: 100px;
  position: fixed;
  width: 36px;
  height: 36px;
  left: 190px;
  top: 59px;
  z-index: 999;
  background: #ffffff;
  box-shadow: 0px 4px 10px 2px rgba(0, 0, 0, 0.08);
}

.menu {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100vh;
  z-index: 10;
  overflow-y: auto;
}

.header {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  height: 40px;
  padding-right: 10px;
  // background: #99c41c;
  background: #fff;
  border: 1px solid #f5f5f5;
  z-index: 999;
  .nav-tab{
    /deep/ .el-tabs__header{
      margin: 0;
    }
    /deep/ .el-tabs__item{
      height: 36px;
      line-height: 36px;
      padding: 0 12px !important;
    }
    /deep/ .el-tabs__nav-next, /deep/ .el-tabs__nav-prev{
      line-height: 36px;
    }
  }
}

.message {
  position: absolute;
  width: 28px;
  height: 28px;
  right: 187px;
  top: 6px;
  border-radius: 100px;
  background: #bbd867;
}

.cart {
  position: absolute;
  width: 28px;
  height: 28px;
  right: 145px;
  top: 6px;
  border-radius: 100px;
  background: #bbd867;
}

.user {
  // position: absolute;
  // right: 25px;
  // top: 8px;
  padding: 0 20px;
  flex-shrink: 0;
}

.logo {
  height: 98px;
}

/deep/.el-icon-arrow-right {
  color: #606266 !important;
}

/deep/.el-menu-item.is-active {
  background: #f5f9e8 !important;
}

/deep/.el-menu-item:focus,
/deep/.el-menu-item:hover {
  color: #bbd867 !important;
  background: #f5f9e8 !important;
}

/deep/.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 208px;
}

.hideSidebar {
  /deep/.el-submenu {
    overflow: hidden;

    .el-submenu__icon-arrow {
      display: none;
    }
  }

  /deep/.el-menu--collapse {
    .el-submenu {
      & > .el-submenu__title {
        & > span {
          height: 0;
          width: 0;
          overflow: hidden;
          visibility: hidden;
          display: inline-block;
        }
      }
    }
  }

  /deep/.el-menu--collapse .el-menu .el-submenu {
    min-width: 208px !important;
  }
}
</style>
